import { useEffect, useState } from "react";
import { X, MessageCircle, Sparkles, ArrowRight } from "lucide-react";
import { waLink } from "@/lib/brand";

const STORAGE_KEY = "ds_welcome_seen_v1";

export default function WelcomePopup() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    try {
      if (sessionStorage.getItem(STORAGE_KEY)) return;
    } catch (e) {}
    const t = setTimeout(() => setOpen(true), 6000);
    return () => clearTimeout(t);
  }, []);

  function close() {
    setOpen(false);
    try { sessionStorage.setItem(STORAGE_KEY, "1"); } catch (e) {}
  }

  if (!open) return null;

  return (
    <div
      data-testid="welcome-popup"
      className="fixed inset-0 z-50 flex items-center justify-center px-4 animate-in fade-in duration-300"
      role="dialog"
      aria-modal="true"
    >
      <button
        aria-label="Close popup background"
        onClick={close}
        className="absolute inset-0 bg-black/70 backdrop-blur-sm"
      />
      <div className="relative w-full max-w-md rounded-3xl border border-[#d4ff4f]/30 bg-[#0a0b08] overflow-hidden shadow-2xl animate-in zoom-in-95 slide-in-from-bottom-4 duration-500">
        <div className="absolute -top-20 -right-20 w-60 h-60 rounded-full bg-[#d4ff4f]/20 blur-3xl pointer-events-none" />
        <div className="absolute -bottom-20 -left-20 w-60 h-60 rounded-full bg-emerald-500/20 blur-3xl pointer-events-none" />

        <button
          data-testid="welcome-close"
          onClick={close}
          className="absolute top-3 right-3 w-9 h-9 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center z-10"
        >
          <X className="w-4 h-4" />
        </button>

        <div className="relative p-7 sm:p-10">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-[#d4ff4f]/30 bg-[#d4ff4f]/5 font-mono text-[10px] uppercase tracking-[0.2em] text-[#d4ff4f] mb-5">
            <Sparkles className="w-3 h-3" />
            Limited · Free 30-min Audit
          </div>
          <h3 className="font-display text-3xl sm:text-4xl tracking-tighter leading-[0.95] mb-4">
            Selling slowly?<br />
            <span className="italic text-[#d4ff4f]">We'll fix that.</span>
          </h3>
          <p className="text-sm text-white/70 leading-relaxed mb-7">
            Book a free 30-minute audit. We'll tear apart your funnel, ad creative and CPL — and tell you exactly what's leaking bookings. No pitch deck, just numbers.
          </p>
          <div className="space-y-3">
            <a
              href={waLink("Hi Digi Savvy! I'd like to claim the free 30-min audit.")}
              target="_blank"
              rel="noreferrer"
              data-testid="welcome-cta-whatsapp"
              onClick={close}
              className="group flex items-center justify-center gap-2 w-full bg-[#d4ff4f] text-black font-semibold px-5 py-3.5 rounded-full hover:bg-white transition"
            >
              <MessageCircle className="w-4 h-4" />
              Claim free audit on WhatsApp
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition" />
            </a>
            <button
              data-testid="welcome-skip"
              onClick={close}
              className="w-full text-xs font-mono uppercase tracking-[0.2em] text-white/40 hover:text-white py-2"
            >
              Maybe later
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
